import React, { useEffect, useState } from 'react';
import { Modal, Input, Alert, Form } from 'antd';
import { connect } from 'react-redux';
import ClearErrors from '../clear_errors/ClearErrors';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../../actions/work_orders_actions';

const { TextArea } = Input;

interface DeclineWorkOrderFormProps {
	visible: boolean;
	onCancel: () => void;
	onSubmit: () => void;
	workOrder: any;
	createErrors: string[];
	updateErrors: string[];
	creating: boolean;
	updating: boolean;
}

const DeclineWorkOrderForm: React.FC<DeclineWorkOrderFormProps> = ({
	visible,
	onCancel,
	onSubmit,
	workOrder,
	createErrors,
	updateErrors,
	creating,
	updating,
}) => {
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({
			workOrder,
		});
	}, [workOrder, form]);

	return (
		<Modal
			visible={visible}
			width={600}
			title="Decline Work Order"
			okText="Decline"
			onCancel={onCancel}
			onOk={() => {
				form.submit();
			}}
			closable={false}
		>
			<Form form={form} layout="vertical" className="supplierForm" onFinish={onSubmit}>
				<ClearErrors actionCreators={WORK_ORDERS_CRUD_ACTION_CREATORS} />

				{createErrors.length > 0 && (
					<Form.Item>
						<Alert message={createErrors.join(' ')} type="error" />
					</Form.Item>
				)}

				{updateErrors.length > 0 && (
					<Form.Item>
						<Alert message={updateErrors.join(' ')} type="error" />
					</Form.Item>
				)}

				<Form.Item
					name="note"
					label="Notes"
					rules={[{ required: true, message: 'Please input your notes!' }]}
				>
					<TextArea />
				</Form.Item>
			</Form>
		</Modal>
	);
};

const mapStateToProps = (state: any) => ({
	createErrors: state.work_orders.createErrors,
	updateErrors: state.work_orders.updateErrors,
	creating: state.work_orders.creating,
	updating: state.work_orders.updating,
});

export default connect(mapStateToProps)(DeclineWorkOrderForm);
